<template>
  <!--    https://codepen.io/joshmanders/pen/PQQBoR -->
  <nav class="flex items-center justify-between flex-wrap bg-teal bg-teal-400 bg-teal p-6">
    <div class="flex items-center flex-no-shrink text-white  mr-6">
      <svg class="fill-current h-8 w-8 mr-2" width="54" height="54" viewBox="0 0 54 54"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"/>
      </svg>
      <span class="font-semibold text-xl tracking-tight">Tailwind CSS</span>
    </div>
    <div class="block sm:hidden">
      <button @click="toggle"
              class="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-200 hover:text-white hover:border-white">
        <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
        </svg>
      </button>
    </div>
    <div :class="open ? 'block': 'hidden'" class="w-full flex-grow sm:flex sm:items-center sm:w-auto">


      <div class="text-sm sm:flex-grow">
        <template v-for="route in routes">

          <router-link
              class="no-underline block mt-4 sm:inline-block sm:mt-0 text-teal-200 hover:text-white mr-4"
              v-bind:to="route.path">{{ route.name }}
          </router-link>

        </template>
      </div>

      <!--        <div>-->
      <!--          <a href="#"-->
      <!--             class="no-underline inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-teal hover:bg-white mt-4 sm:mt-0">Download</a>-->
      <!--        </div>-->

    </div>
  </nav>

  <router-view></router-view>
</template>

<script>
import {routes} from '@/router';
export default {
  data() {
    return {
      routes: routes,
      open: false,
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    }
  }
}
</script>

<style lang="scss">
//@import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900");

#app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  //-webkit-font-smoothing: antialiased;
  //-moz-osx-font-smoothing: grayscale;
  //text-align: center;
  //color: #2c3e50;

  //min-height: 100vh;

  @apply min-h-screen;

  @apply font-sans antialiased;
  /*@apply font-sans;*/
  /*@apply antialiased*/
  font-family: "Roboto", sans-serif;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  &.router-link-exact-active {
    color: #42b983;
    color: black;
  }
}

//#nav {
//  padding: 30px;
//
//  a {
//    font-weight: bold;
//    color: #2c3e50;
//
//    &.router-link-exact-active {
//      color: #42b983;
//    }
//  }
//}
</style>
